// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_71-3";
export var contentContainer = "_71-0";
export var editorContainer = "_71-1";
export var quillInputForm = "_71-2";
export var zoneDivider = "_71-4";